import { render, staticRenderFns } from "./Myship.vue?vue&type=template&id=3a2347bd&"
import script from "./Myship.vue?vue&type=script&lang=js&"
export * from "./Myship.vue?vue&type=script&lang=js&"
import style0 from "./Myship.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports